module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "$",
	"sourceName": "contracts/levels/FakerDAO.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220200e978edf9db489bfad6c51589707fd8f7f1152837a46caf52eef9a786bf35f64736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220200e978edf9db489bfad6c51589707fd8f7f1152837a46caf52eef9a786bf35f64736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/FakerDAO.sol/$.json
// module id = 1553
// module chunks = 0